import useParsedQueryString from "hooks/useParsedQueryString";
import logError from "utils/logError";

const logAndReturn = () => {
  logError("An ill-formatted filter[] query string parameter was encountered", {
    functionName: "useQueryFilterValue",
  });

  return [];
};

const useQueryFilterValues = (filterName: string): string[] => {
  const { filter: queryFilters } = useParsedQueryString();

  // * "filter" is a reserved query string term that should be an encoded set of API filter params.
  // * Each entry should be either a string or string array.
  if (typeof queryFilters == "object" && !Array.isArray(queryFilters)) {
    const { [filterName]: appliedFilterValue = [] } = queryFilters;

    if (Array.isArray(appliedFilterValue)) {
      // * Typescript trickery to only consider string values, and ignore anything else.
      return appliedFilterValue.filter((item) => typeof item === "string");
    } else {
      // * We only allow string values. If filter[name] is a deeper complex object, log & ignore it.
      return typeof appliedFilterValue == "string"
        ? [appliedFilterValue]
        : logAndReturn();
    }
  } else {
    if (queryFilters != null) {
      return logAndReturn(); // * the filter query string is not a formatted object...
    }

    // * Don't log anything if the filter is just empty / blank.
    return [];
  }
};

export default useQueryFilterValues;
